module.exports = __webpack_public_path__ + "img/jd2021_p.a2bb976a.png";